import { ProductData } from 'utils/types';
import {
  StyledChestProduct,
  StyledChestQuantity,
  StyledQuantity,
} from './style';
import { useMemo } from 'react';
import { Box } from '@mui/material';

interface IMainChestProductProps {
  mainProduct: ProductData;
}

const rarityStarImg =
  'https://media-staging.appcharge.com/media/66df27221b94686899040058/1727771980837__c7c9965b-8719-4348-ace6-91374c89c6c1';

export const MainChestProduct: React.FC<IMainChestProductProps> = ({
  mainProduct,
}) => {
  const starsArray = useMemo(
    () =>
      Array.from({
        length: mainProduct?.rarityProductInfo?.stars || 0,
      }),
    [mainProduct?.rarityProductInfo?.stars],
  );

  return (
    <StyledChestProduct className={'hov-chest-product'}>
      <div className={'hov-main-product_product-img'}>
        <img src={mainProduct.images.product} alt="product" />
      </div>

      <div className={'chest-stars-section'}>
        <Box gap="2px" className={'stars-section-container'}>
          {mainProduct.rarityProductInfo?.rarityText && (
            <StyledQuantity
              fontSize={14}
              title={mainProduct.rarityProductInfo.rarityText}
            >
              <div className="quantity_text">
                {mainProduct.rarityProductInfo.rarityText}
              </div>
            </StyledQuantity>
          )}
          {starsArray?.map((_, index) => (
            <img key={index} src={rarityStarImg} alt="rarity star" />
          ))}
        </Box>
        <StyledChestQuantity>
          <div className="quantity_text">{mainProduct.quantityDisplay}</div>
        </StyledChestQuantity>
      </div>
    </StyledChestProduct>
  );
};
